<template>
    <div class="form-component">
        <v-form ref="form" v-model="valid">
            <h3 class="form-title">
                <v-btn fab color="primary" @click="goTo('/NotificationList')">
                    <v-icon large>arrow_left</v-icon>
                </v-btn>
                {{ title }} Notificaciones
            </h3>
            <v-container fluid class="pa-0">
                <v-layout row wrap>
                    <v-flex xs12 sm3>
                        <v-text-field class="lance"
                            label="Código"
                            v-model="form.code"
                            :disabled="view">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12>
                        <v-text-field class="lance"
                            label="Nombre"
                            v-model="form.name"
                            :rules="[v => !!v || 'Campo requerido']"
                            :disabled="view">
                        </v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-select class="lance"
                            :items="status"
                            item-text="internalText"
                            item-value="id"
                            v-model="form.newStatus"
                            label="Estatus"
                            :rules="[v => !!v || 'Campo requerido', v => v.length>0 || 'Campo requerido']"
                            :disabled="view"
                            multiple>
                            <v-list-tile v-if="form.newStatus" slot="prepend-item" @click="form.newStatus = null;">
                                <v-list-tile-action><v-icon>close</v-icon></v-list-tile-action>
                                <v-list-tile-title>Limpiar</v-list-tile-title>
                            </v-list-tile>
                            <v-divider v-if="form.newStatus" slot="prepend-item" class="mt-2"></v-divider>
                        </v-select>
                    </v-flex>
                    <v-flex xs12 sm6>
                        <v-select class="lance"
                            :items="users"
                            item-text="username"
                            item-value="id"
                            v-model="form.newUsers"
                            label="Usuarios"
                            :rules="[v => !!v || 'Campo requerido', v => v.length>0 || 'Campo requerido']"
                            :disabled="view"
                            multiple>
                            <v-list-tile v-if="form.newUsers" slot="prepend-item" @click="form.newUsers = null;">
                                <v-list-tile-action><v-icon>close</v-icon></v-list-tile-action>
                                <v-list-tile-title>Limpiar</v-list-tile-title>
                            </v-list-tile>
                            <v-divider v-if="form.supplier" slot="prepend-item" class="mt-2"></v-divider>
                        </v-select>
                    </v-flex>
                    <v-flex xs12>
                        <v-textarea
                            rows="15"
                            v-model="form.body"
                            label="Cuerpo del correo"
                            class="lance body-block"
                            :rules="[v => !!v || 'Campo requerido']"
                            :disabled="view">
                        </v-textarea>
                    </v-flex>
                </v-layout>

                <v-layout row wrap>
                    <v-flex xs12 md4>
                        <v-btn v-if="!view"
                            solo
                            color="submitBtn"
                            @click="save()"
                            :disabled="!valid || sending">Guardar</v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-form>
    </div>
</template>

<style scoped>
.body-block /deep/ .v-input__control > .v-input__slot {
    padding-left: 50px;
    padding-right: 20px;
}

.body-block /deep/ .v-input__control textarea{
    margin-top: 15px !important;
}
</style>

<script>
    import { events } from '../main';
    import { _ } from 'underscore';
    import moment from 'moment-timezone';
    import VueGridLayout from 'vue-grid-layout';

    export default {
        name: 'Notificationform',
        components: {
        },
        data() {
            return {
                title: 'Crear',
                status: [],
                users: [],
                valid: true,
                sending: false,
                testing: false,
                view: false,
                id: '',
                form: {
                },
                credentials: JSON.parse(localStorage.getItem('userCredentials')),
            }
        },
        methods: {
            snackbar(message) {
                events.$emit('snackbar', message);            
            },
            goTo(url) {
                this.$router.push(url);
            },
            dataInit() {
                var self = this;
                if (this.id) {
                    this.getRegistry(this.id);
                } else {
                    this.$http.get('NotificationConfiguration/form')
                    .then(response => {
                        var newform = response.body.NotificationConfiguration;
                        this.form = newform;
                        this.filterUsedStatuses();
                    });
                }
            },
            filterUsedStatuses() {
                this.$http.get('NotificationConfiguration/statuses')
                .then(response => {
                    var ids = response.body;
                    if (this.id) {
                        ids = ids.filter(x => !this.form.status.includes(x));
                    }
                    this.status = this.status.filter(x => !ids.includes(x.id));
                })
            },
            getRegistry(id) {
                this.$http.get('NotificationConfiguration/form/' + this.id)
                .then(response => {
                    this.form = Object.assign({}, response.body.NotificationConfiguration);
                    this.form.users = _.pluck(this.form.NotificationConfigurationUsers, 'userId');
                    this.$set(this.form, "newUsers", this.form.users);
                    this.form.status = _.pluck(this.form.NotificationConfigurationStatus, 'status');
                    this.filterUsedStatuses();
                    this.$set(this.form, "newStatus", this.form.status);
                }, error => {
                    this.snackbar('Error al obtener registro');
                    this.goBack();
                });
            },
            getStatuses: function() {
                this.$http.get('Status')
                    .then(response => {
                        var list = response.body;
                        this.status = list;
                    }, error => {
                        this.snackbar('Hubo un problema al obtener la lista de estatus');
                        console.error(error);
                    })
            },
            getUsers: function() {
                this.$http.get('NotificationConfiguration/user')
                    .then(response => {
                        var list = response.body;
                        this.users = list;
                    }, error => {
                        this.snackbar('Hubo un problema al obtener la lista de usuarios');
                        console.error(error);
                    })
            },
            save() {
                if (this.$refs.form.validate()) {
                    this.sending = true;
                    this.form.updatedById = localStorage.getItem('userId');
                    if (this.id) {
                        this.form.badUsers = this.form.users.filter(x => !this.form.newUsers.includes(x));
                        this.form.badStatus = this.form.status.filter(x => !this.form.newStatus.includes(x));
                        this.form.addUsers = this.form.newUsers.filter(x => !this.form.users.includes(x));
                        this.form.addStatus = this.form.newStatus.filter(x => !this.form.status.includes(x));
                        this.$http.put('NotificationConfiguration/' + this.id, this.form)
                            .then(response => {
                                this.snackbar('Registro actualizado con éxito');
                                this.$router.push('/NotificationList');                              
                            }, error => {
                                this.sending = false;                                
                                this.snackbar(error.body.msg || 'Error al actualizar registro');
                        });
                    } else {
                        this.form.createdById = localStorage.getItem('userId');
                        this.$http.post('NotificationConfiguration/', this.form)
                            .then(response => {
                                this.snackbar('Registro creado con éxito');
                                this.$router.push('/NotificationList');   
                            }, error => {
                                this.sending = false;
                                this.snackbar(error.body.msg || 'Error al crear registro');
                        });
                    }
                }
            },
            gridItem(id) {
                return this.layout.filter(x => x.i === id)[0];
            },
        },
        mounted() {
            this.id = this.$route.params.id;
            if (this.$route.name.includes('detail') ) {
                this.view = true;
                this.title = "Detalle";
            } else if (this.$route.name.includes('edit')) {
                this.view = false;
                this.title = "Editar";
            }
            this.getUsers();
            this.getStatuses();
            this.dataInit();
        }
    }
</script>